import { get } from 'svelte/store';
import { home_data, user_data } from 'src/stores/account/user';
import { save_home } from 'src/helpers/home_helpers';
import { isSubUnit } from 'src/helpers/user_helpers';
import { getOwnedHomeCount } from 'src/helpers/houses/homes_helpers';

export const HOMES_WHATS_NEW_KEY = 'homesWhatsNew';

/** Update before release — used to re-show the intro after copy changes. */
export const HOMES_WHATS_NEW_RELEASE_TIMESTAMP = Math.floor(
	new Date('2026-06-01T00:00:00Z').getTime() / 1000,
);

const HOMES_WHATS_NEW_NEVER_SEEN = 0;

export function isHomesWhatsNewSeen(
	homeData: Record<string, unknown> | undefined = get(home_data) as Record<string, unknown>,
): boolean {
	const seenAt = homeData?.[HOMES_WHATS_NEW_KEY];
	return typeof seenAt === 'number' && seenAt >= HOMES_WHATS_NEW_RELEASE_TIMESTAMP;
}

export function shouldShowHomesWhatsNew(
	homeData: Record<string, unknown> | undefined = get(home_data) as Record<string, unknown>,
): boolean {
	if (isSubUnit()) return false;
	// The seen-flag is stored per home, so a freshly created/received home would
	// re-trigger this intro. Owning more than one home means the user already
	// knows about Multiple Homes, so don't re-announce it on every new home.
	if (getOwnedHomeCount(get(user_data).available_units) > 1) return false;
	return !isHomesWhatsNewSeen(homeData);
}

export async function markHomesWhatsNewSeen(): Promise<boolean> {
	const res = await save_home(HOMES_WHATS_NEW_KEY, HOMES_WHATS_NEW_RELEASE_TIMESTAMP);
	return res?.isok === true;
}
